<div class="container-idle">
	<div class="modal" tabindex="-1">
		<div class="modal-dialog">
			<div class="modal-content">
				<div class="modal-header">
					<h1>Información complementaria</h1>
					<h1 style="left: 0;" class="i-hover"><i class="fa fa-xmark" (click)="close.emit(false)"></i></h1>
				</div>
				<div class="modal-body">
					<div class="row">
						<div class="col-sm" style="display: flex; justify-content: center;">
							<div class="user-container">
								<ng-container *ngIf="!loadingImage">
									<img *ngIf="!newEmployee.foto" src="/assets/img/user_avatar.png" width="200px"
										alt="">
									<img *ngIf="newEmployee.foto"
										src="https://s3.amazonaws.com/rrhh-images/payroll/employee/photo/{{newEmployee.foto}}"
										width="200px" alt="">
									<div class="container-image" (click)="uploadingImage = true">
										<span tooltip="Subir imagen" class="display-3 icon"><i
												class="fa fa-upload"></i></span>
									</div>
								</ng-container>
								<ng-container *ngIf="loadingImage">
									<div class="container-spinner">
										<span class="spinner-border spinner-border-sm spinner-custom"
											aria-hidden="true"></span>
									</div>
								</ng-container>
							</div>
						</div>
						<div class="col-sm" class="col-documents">
							<div class="form-group" style="margin-bottom: 1em;">
								<label for="document" class="form-label">Documento de identificación</label>
								<div class="input-group input-group-sm">
									<label for="document" class="input-group-text">
										<ng-container *ngIf="uploadingID">
											<span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
										</ng-container>
										<ng-container *ngIf="!uploadingID">
											<i [tooltip]="newEmployee.documento?'Documento subido previamente':'Aún no se han subido el documento de identificación'"
												[ngClass]="newEmployee.documento?'text-success fa fa-circle-check':'text-danger fa-regular fa-file'"></i>
										</ng-container>
									</label>
									<input type="button" [disabled]="uploadingID" (click)="uploadID()" id="document"
										[value]="newEmployee.documento?'CAMBIAR':'AGREGAR'" name="document"
										class="form-control ibtn-primary">
								</div>
							</div>
							<div class="form-group" style="margin-bottom: 1em;">
								<label for="penal" class="form-label">Carencia de Antecedentes Penales</label>
								<div class="input-group input-group-sm">
									<label for="penal" class="input-group-text">
										<ng-container *ngIf="uploadingPenal">
											<span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
										</ng-container>
										<ng-container *ngIf="!uploadingPenal">
											<i [tooltip]="newEmployee.penales?'Antecedentes subidos previamente':'Aún no se han subido antecedentes penales'"
												[ngClass]="newEmployee.penales?'text-success fa fa-circle-check':'text-danger fa-regular fa-file'"></i>
										</ng-container>
									</label>
									<input type="button" id="policy" [disabled]="uploadingPenal" (click)="uploadPenal()"
										[value]="newEmployee.policiacos?'CAMBIAR':'AGREGAR'" name="policy"
										class="form-control ibtn-primary">
								</div>
							</div>
							<div class="form-group" style="margin-bottom: 1em;">
								<label for="id" class="form-label">Carencia de Antecedentes Policiacos</label>
								<div class="input-group input-group-sm">
									<label for="policy" class="input-group-text">
										<ng-container *ngIf="uploadingPolicy">
											<span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
										</ng-container>
										<ng-container *ngIf="!uploadingPolicy">
											<i [tooltip]="newEmployee.policiacos?'Antecedentes subidos previamente':'Aún no se han subido antecedentes policiacos'"
												[ngClass]="newEmployee.policiacos?'text-success fa fa-circle-check':'text-danger fa-regular fa-file'"></i>
										</ng-container>
									</label>
									<input type="button" id="policy" [disabled]="uploadingPolicy"
										(click)="uploadPolicy()" [value]="newEmployee.policiacos?'CAMBIAR':'AGREGAR'"
										name="policy" class="form-control ibtn-primary">
								</div>
							</div>
							<div class="form-group" style="margin-bottom: 1em;">
								<label for="id" class="form-label">Contrato de trabajo</label>
								<div class="input-group input-group-sm">
									<label for="policy" class="input-group-text">
										<ng-container *ngIf="uploadingWorkContract">
											<span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
										</ng-container>
										<ng-container *ngIf="!uploadingWorkContract">
											<i [tooltip]="newEmployee.workContract?'Contrato de trabajo subido anteriormente':'Aún no se ha subido contrato de trabajo'"
												[ngClass]="newEmployee.workContract?'text-success fa fa-circle-check':'text-danger fa-regular fa-file'"></i>
										</ng-container>
									</label>
									<input type="button" id="policy" [disabled]="uploadingWorkContract"
										(click)="uploadWorkContract()" [value]="newEmployee.workContract?'CAMBIAR':'AGREGAR'"
										name="policy" class="form-control ibtn-primary">
								</div>
							</div>
							<div class="form-group" style="margin-bottom: 1em;">
								<label for="id" class="form-label">Pruebas Psicometricas</label>
								<div class="input-group input-group-sm">
									<label for="policy" class="input-group-text">
										<ng-container *ngIf="uploadingPsycometricTest">
											<span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
										</ng-container>
										<ng-container *ngIf="!uploadingPsycometricTest">
											<i [tooltip]="newEmployee.psychometricTests?'Pruebas Psicometricas subidos previamente':'Aún no se han subido Pruebas Psicometricas'"
												[ngClass]="newEmployee.psychometricTests?'text-success fa fa-circle-check':'text-danger fa-regular fa-file'"></i>
										</ng-container>
									</label>
									<input type="button" id="policy" [disabled]="uploadingPsycometricTest"
										(click)="uploadPsicommetricTest()" [value]="newEmployee.psychometricTests?'CAMBIAR':'AGREGAR'"
										name="policy" class="form-control ibtn-primary">
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
<app-modal-upload-image *ngIf="uploadingImage" (close)="closeUploadImage($event)"></app-modal-upload-image>